import {
  CreditCardIcon,
  CurrencyDollarIcon,
  KeyIcon,
  SparklesIcon,
  TruckIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";
import MenuItemCard from "../../Components/MenuItemCard";

const MENU_ITEMS = [
  {
    id: "pph-21-26",
    icon: UserGroupIcon,
    titleKey: "taxCalculator.pph2126.title",
    descriptionKey: "taxCalculator.pph2126.description",
    route: "/tax-calculator/pph-21-26",
    available: true,
  },
  {
    id: "pph-22",
    icon: TruckIcon,
    titleKey: "taxCalculator.pph22.title",
    descriptionKey: "taxCalculator.pph22.description",
    route: "/tax-calculator/pph-22",
    available: false,
  },
  {
    id: "pph-23",
    icon: CreditCardIcon,
    titleKey: "taxCalculator.pph23.title",
    descriptionKey: "taxCalculator.pph23.description",
    route: "/tax-calculator/pph-23",
    available: true,
  },
  {
    id: "pph-final-42",
    icon: KeyIcon,
    titleKey: "taxCalculator.pphFinal42.title",
    descriptionKey: "taxCalculator.pphFinal42.description",
    route: "/tax-calculator/pph-final-4-2",
    available: true,
  },
  {
    id: "ppn",
    icon: CurrencyDollarIcon,
    titleKey: "taxCalculator.ppn.title",
    descriptionKey: "taxCalculator.ppn.description",
    route: "/tax-calculator/ppn",
    available: false,
  },
  {
    id: "ppnbm",
    icon: SparklesIcon,
    titleKey: "taxCalculator.ppnbm.title",
    descriptionKey: "taxCalculator.ppnbm.description",
    route: "/tax-calculator/ppnbm",
    available: false,
  },
];

const TaxCalculator = () => {
  return (
    <div className="max-w-5xl">
      <div className="grid grid-cols-6 gap-4 items-stretch">
        {MENU_ITEMS.filter((item) => item.available).map((item) => (
          <MenuItemCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};

export default TaxCalculator;
